// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTInternetProxySettings,
    RESTLinkHAL,
    RESTProxyOperatingSystem,
    RESTProxyRole,
} from './';

/**
 * @export
 * @interface RESTProxy
 */
export interface RESTProxy {
    /**
     * Type of the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    type?: RESTProxyTypeEnum;
    /**
     * Defines whether Veeam Backup for Microsoft 365 will use an internet proxy server to process backup and backup copy jobs.
     * @type {boolean}
     * @memberof RESTProxy
     */
    useInternetProxy?: boolean | null;
    /**
     * Type of the internet proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    internetProxyType?: RESTProxyInternetProxyTypeEnum;
    /**
     * @type {RESTProxyOperatingSystem}
     * @memberof RESTProxy
     */
    operatingSystem?: RESTProxyOperatingSystem;
    /**
     * @type {RESTInternetProxySettings}
     * @memberof RESTProxy
     */
    internetProxySettings?: RESTInternetProxySettings;
    /**
     * Backup proxy server ID.
     * @type {string}
     * @memberof RESTProxy
     */
    id?: string | null;
    /**
     * Backup proxy pool ID.
     * @type {string}
     * @memberof RESTProxy
     */
    proxyPoolId?: string | null;
    /**
     * DNS name or IP address of the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    hostName?: string;
    /**
     * Fully qualified domain name of the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    fqdn?: string;
    /**
     * Description of the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    description?: string;
    /**
     * Port number to connect to the backup proxy server.
     * @type {number}
     * @memberof RESTProxy
     */
    port?: number | null;
    /**
     * Defines whether Veeam Backup for Microsoft 365 limits the network bandwidth for performance optimization.
     * @type {boolean}
     * @memberof RESTProxy
     */
    enableNetworkThrottling?: boolean | null;
    /**
     * Value of the network bandwidth limit.
     * @type {number}
     * @memberof RESTProxy
     */
    throttlingValue?: number | null;
    /**
     * Measuring unit for the network bandwidth limit.
     * @type {string}
     * @memberof RESTProxy
     */
    throttlingUnit?: RESTProxyThrottlingUnitEnum;
    /**
     * Status of the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    status?: RESTProxyStatusEnum;
    /**
     * State of the maintenance mode for the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    maintenanceModeState?: RESTProxyMaintenanceModeStateEnum;
    /**
     * Percent of CPU usage for the backup proxy server.
     * @type {number}
     * @memberof RESTProxy
     */
    cpuUsagePercent?: number | null;
    /**
     * Percent of memory usage for the backup proxy server.
     * @type {number}
     * @memberof RESTProxy
     */
    memoryUsagePercent?: number | null;
    /**
     * Version of Veeam Backup for Microsoft 365 installed on the backup proxy server.
     * @type {string}
     * @memberof RESTProxy
     */
    version?: string | null;
    /**
     * Service account that is used to run *Veeam Backup for Microsoft 365 Proxy Service*.
     * @type {string}
     * @memberof RESTProxy
     */
    serviceAccount?: string | null;
    /**
     * Roles assigned to the backup proxy server.
     * @type {Array<RESTProxyRole>}
     * @memberof RESTProxy
     */
    role?: Array<RESTProxyRole>;
    /**
     * Related resources.
     * @type {{ [key: string]: RESTLinkHAL; }}
     * @memberof RESTProxy
     */
    _links?: { [key: string]: RESTLinkHAL; };
}

/**
 * @export
 * @enum {string}
 */
export enum RESTProxyTypeEnum {
    Local = 'Local',
    Domain = 'Domain',
    Workgroup = 'Workgroup'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTProxyInternetProxyTypeEnum {
    FromManagementServer = 'FromManagementServer',
    Custom = 'Custom'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTProxyThrottlingUnitEnum {
    Mbps = 'Mbps',
    Mbs = 'MBs',
    Kbs = 'KBs'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTProxyStatusEnum {
    Online = 'Online',
    Offline = 'Offline'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTProxyMaintenanceModeStateEnum {
    Disabled = 'Disabled',
    Enabling = 'Enabling',
    Enabled = 'Enabled'
}

